import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import TextField from 'src/components/TextField';
import { OrderMessagesOnExpeditionBoxType } from 'src/types/orderMessagesOnExpeditionBox';
import getCountryOptions from 'src/utils/countryOptions';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: OrderMessagesOnExpeditionBoxType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.MESSAGE}
                    error={props.editErrors.MESSAGE}
                    onChange={(value, error) => props.onChange('MESSAGE', value, error)}
                    name="MESSAGE"
                    label={translate('orderMessagesOnExpeditionBoxDetail.message')}
                    fullWidth
                    disabled={props.disableEdit}
                    multiline
                    required
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={getCountryOptions()}
                    value={props.editData.COUNTRY}
                    error={props.editErrors.COUNTRY}
                    onChange={(value, error) => props.onChange('COUNTRY', value || '', error)}
                    name="COUNTRY"
                    label={translate('orderMessagesOnExpeditionBoxDetail.country')}
                    fullWidth
                    disabled={props.disableEdit}
                    emptyOption
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
